import React, {useEffect} from 'react';
import {
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonButton,
    IonIcon,
} from '@ionic/react';
import {
    menuOutline, notifications as notificationsIcon,
} from 'ionicons/icons';
import appLogo from '../theme/images/logo-big.png';
import {useHistory, useLocation} from "react-router";
import {hideBanner} from "../lib/ads";

const menuDesktopTopItems = [
    { label: 'About AICAS', pathName:'/about-us' },
    { label: 'Become a Member', pathName: '/membership' },
    { label: 'Policy', pathName:'/policy' },
    { label: 'Deactivate Account', pathName:'/deactivate' },
    { label: 'Contact Us', pathName:'/contact-us' },
];


const HeaderWithoutLoginComponent = ({hideHeader,menuRef,setCurrentPath,menuOpen,setMenuOpen,isMobile}) => {
    const {pathname} = useLocation();
    const history = useHistory();


    const goToPage =(page)=>{
        const menu = menuRef.current;
        if(isMobile){
            history.replace(page);
            setCurrentPath(page);
            if (menu) {
                menu?.close();
            }
        }else{
            history.replace(page);
            setCurrentPath(page);
            if (menu) {
                menu?.close();
            }
        }
    }

    useEffect(() => {
        // Setup menu event listeners when component mounts
        const setupMenuListeners = () => {
            const menu = document.querySelector('ion-menu');
            if (menu) {
                menuRef.current = menu;
                menu.addEventListener('ionDidOpen', handleMenuOpen);
                menu.addEventListener('ionDidClose', handleMenuClose);
            }
        };

        const handleMenuOpen = () => setMenuOpen(true);
        const handleMenuClose = () => setMenuOpen(false);

        // Ionic components might not be ready immediately
        const timer = setTimeout(setupMenuListeners, 300);

        return () => {
            clearTimeout(timer);
            if (menuRef.current) {
                menuRef.current.removeEventListener('ionDidOpen', handleMenuOpen);
                menuRef.current.removeEventListener('ionDidClose', handleMenuClose);
            }
        };
    }, []);

    const toggleMenu = () => {
        const menu = menuRef.current; // pass this ref down via props
        if (!menu) return;
        menu.isOpen().then((open) => {
            if(open){
                menu.close()
            }else{
                menu.open()
                hideBanner();
            }
        });
    };

    return (
        <IonHeader className={`with_login-header main_app_header`}>
            <IonToolbar className={`with_login-toolbar with_sub_heading_toolbar ${hideHeader ? 'hide_element' : ''}`}>
                {(isMobile) ?
                    <IonButtons slot="start">
                        <IonButton
                            onClick={toggleMenu}
                            className={`with_login-menu-button ${menuOpen ? 'open' : ''}`}
                        >
                            <IonIcon icon={menuOutline} className="avatar-icon menu-hamburger" />
                        </IonButton>
                    </IonButtons>:''
                }

                {isMobile ? (
                        <div slot="start" className="with_login-title_in_center_mob">
                            <img src={appLogo} alt="Logo" className="with_login-logo-mob"/>
                        </div>
                    )
                    : (
                        <IonTitle slot="start" className="with_login-title">
                            <img src={appLogo} alt="Logo" className="with_login-logo"/>
                        </IonTitle>
                )}
                {isMobile ?
                <IonButtons style={{opacity:0}} slot="end" className="with_login-icons">
                    <IonButton className="header_button">
                        <div className="notification-icon">
                            <IonIcon icon={notificationsIcon}/>
                        </div>
                    </IonButton>
                </IonButtons>:''
                }

                {!isMobile && (
                    <IonButtons slot="start" className="with_login-desktop-menu">
                        {menuDesktopTopItems.map((item, index) => (
                            <div
                                key={index}
                                className="menu-item-wrapper desktop-menu-top"
                            >
                                <div
                                    className={`menu-item ${
                                        pathname === item?.pathName ? 'active' : ''
                                    }`}
                                    onClick={() => goToPage(item.pathName)}
                                >
                                    <span>{item.label}</span>
                                    {item.children && <span className="arrow">▾</span>}
                                </div>
                            </div>
                        ))}
                    </IonButtons>
                )}
                {(!isMobile) ?
                    <IonButtons slot="end" className="with_login-icons">
                        <div className="menu-item-wrapper desktop-menu-top" onClick={() => goToPage('/signup')}>
                            <div
                                className={`menu-item ${
                                    pathname === '/signup' ? 'active' : ''
                                }`}><span>Register</span></div>
                        </div>
                        <div className="menu-item-wrapper desktop-menu-top" onClick={() => goToPage('/login')}>
                            <div
                                className={`menu-item ${
                                    pathname === '/login' ? 'active' : ''
                                }`}><span>Login</span></div>
                        </div>
                    </IonButtons>
                    : ''
                }
            </IonToolbar>
        </IonHeader>
    );
};

export default HeaderWithoutLoginComponent;